import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationTaxRequestApiService } from '../index';
import { create4506CMutation, get4506cViewUrls, IDocumentProcessorResponse, SignerInput } from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class ApplicationTaxRequestGqlService
  implements ApplicationTaxRequestApiService {
  constructor(private apollo: Apollo) {}

  public get4506cViewUrls(
    applicationId: string,
    approvalTaskId: string,
    dwellingId: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    returnUrl:string
  ): Observable<any> {
    return this.apollo
      .mutate({
        mutation: get4506cViewUrls,
        variables: {
          applicationId,
          approvalTaskId,
          dwellingId,
          signer1,
          signer2,
          email,
          envelopeId,
          documentId,
          returnUrl
        }
      })
      .pipe(map(result => result.data['get4506cViewUrls']));
  }

  public createTaxRequestForms(
    applicationId: string,
    dwellingId: string,
    applicationSgStatus: number, 
    approvalTaskId: string,
    approvalTaskItemKey: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    attempt:number,
    returnUrl:string,
    isBorrowerAssisted:boolean
  ): Observable<any> {
    return this.apollo
      .mutate({
        mutation: create4506CMutation,
        variables: {
          applicationId,
          dwellingId,
          applicationSgStatus,
          approvalTaskId,
          approvalTaskItemKey,
          signer1,
          signer2,
          email,
          envelopeId,
          documentId,
          attempt,returnUrl,isBorrowerAssisted
        }
      })
      .pipe(map(result => result.data['create4506C']));
  }
}
